export default {
    name: "publishers",
    svg: "<path d='M5 4H19V6H5V4ZM5 14H9V20H15V14H19L12 7L5 14ZM13 12V18H11V12H9.83L12 9.83L14.17 12H13Z' fill='fillcolor'/>"
}
